import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var LogOut = createReactComponent("LogOut", ["svg", defaultAttributes, [["path", {
  d: "M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4",
  key: "1wlf0y"
}], ["polyline", {
  points: "16 17 21 12 16 7",
  key: "xjwp0i"
}], ["line", {
  x1: "21",
  y1: "12",
  x2: "9",
  y2: "12",
  key: "1g0nry"
}]]]);
export default LogOut;